import { render, staticRenderFns } from "./UserPicker.vue?vue&type=template&id=b0b9e4c6&scoped=true"
import script from "./UserPicker.vue?vue&type=script&lang=js"
export * from "./UserPicker.vue?vue&type=script&lang=js"
import style0 from "./UserPicker.vue?vue&type=style&index=0&id=b0b9e4c6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b9e4c6",
  null
  
)

export default component.exports